import { classRegex } from '../class-regex';
import { getClass } from '../get-class';

export function hasClass(element: Element, className: string): boolean {
	return element && classRegex(className).test(getClass(element));
}
